import { inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

export abstract class BaseDialog<T = unknown> {
  protected data = inject(MAT_DIALOG_DATA) as T;

  handleConfirm() {
    throw new Error('Method not implemented');
  }
}
